/**
 * ============================================================
 * Whatdaphin.com × PostHog — Core Event Tracking
 * ============================================================
 * Installation: Add to Shopify Admin > Online Store > Themes
 *   > Edit Code > Assets > posthog-tracking.js (new file)
 * Then include in theme.liquid before </body>:
 *   {{ 'posthog-tracking.js' | asset_url | script_tag }}
 *
 * BEFORE USE: Replace YOUR_POSTHOG_API_KEY below with your
 * actual PostHog Project API Key (Settings > Project API Key)
 * ============================================================
 */
 
(function () {
  'use strict';
 
  // ─── CONFIG ────────────────────────────────────────────────
  const POSTHOG_API_KEY = 'phc_tUx7aQfz1qBj3KyBTczcoVWL1rahBL4y5As0WG6mR9xs'; // ← Replace this
  const POSTHOG_HOST    = 'https://app.posthog.com'; // or your EU host
 
  // ─── INIT ──────────────────────────────────────────────────
  // PostHog snippet loader (paste your full snippet from PostHog
  // Settings > Install PostHog here, OR use the npm package).
  // The snippet sets window.posthog. If you already load PostHog
  // via theme.liquid, remove this init block and keep everything below.
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]);t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(a!==void 0?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return a!=="posthog"&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
 
  posthog.init(POSTHOG_API_KEY, {
    api_host:               POSTHOG_HOST,
    capture_pageview:       true,
    capture_pageleave:      true,
    session_recording: {
      maskAllInputs:        false,  // we want to see form interactions
      maskInputOptions: {
        password:           true,   // always mask passwords
        creditcard:         true,   // always mask card numbers
      }
    },
    persistence:            'localStorage+cookie',
    loaded: function (ph) {
      // Register super properties — attached to EVERY event
      ph.register({
        shop_name:          'whatdaphin',
        platform:           'shopify',
        theme_name:         window.Shopify && Shopify.theme ? Shopify.theme.name : 'unknown',
        // UTM params — PostHog captures these automatically,
        // but we explicitly persist them across the session
        utm_source:         getUrlParam('utm_source')  || ph.get_property('utm_source')  || '',
        utm_medium:         getUrlParam('utm_medium')  || ph.get_property('utm_medium')  || '',
        utm_campaign:       getUrlParam('utm_campaign')|| ph.get_property('utm_campaign')|| '',
        is_mobile:          /Mobi|Android/i.test(navigator.userAgent),
      });
    }
  });
 
  // ─── HELPERS ───────────────────────────────────────────────
  function getUrlParam(key) {
    return new URLSearchParams(window.location.search).get(key) || '';
  }
 
  function getScrollDepthPct() {
    var scrolled  = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    return docHeight > 0 ? Math.round((scrolled / docHeight) * 100) : 0;
  }
 
  function secondsSincePageLoad() {
    return Math.round((Date.now() - window._phPageLoadTime) / 1000);
  }
 
  function isReturningCustomer() {
    // Shopify sets a cookie '__shopify_y' for known customers
    // We also check localStorage for our own flag set post-purchase
    return document.cookie.indexOf('_shopify_customerId') > -1
        || localStorage.getItem('wdp_returning') === '1';
  }
 
  // Session counter — incremented on each new session
  var sessionNumber = parseInt(localStorage.getItem('wdp_session_count') || '0') + 1;
  localStorage.setItem('wdp_session_count', sessionNumber);
  posthog.register({ session_number: sessionNumber });
 
  // Page load timestamp for time-on-page calculations
  window._phPageLoadTime = Date.now();
 
  // ─── IDENTITY STITCHING ────────────────────────────────────
  // Shopify exposes customer data on the storefront if logged in.
  // window.ShopifyAnalytics.meta.page.customerId is available on
  // account pages. For checkout identity, see posthog-checkout-pixel.js
  if (window.ShopifyAnalytics && ShopifyAnalytics.meta) {
    var meta = ShopifyAnalytics.meta;
    if (meta.page && meta.page.customerId) {
      posthog.identify(String(meta.page.customerId), {
        shopify_customer_id: meta.page.customerId,
        is_returning_customer: true
      });
      localStorage.setItem('wdp_returning', '1');
    }
  }
 
  // ═══════════════════════════════════════════════════════════
  // 1. PRODUCT PAGE EVENTS
  // ═══════════════════════════════════════════════════════════
  if (window.location.pathname.indexOf('/products/') > -1) {
 
    var productData = {};
 
    // Pull product data from Shopify's global object
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      var p = ShopifyAnalytics.meta.product;
      productData = {
        product_id:    String(p.id),
        product_name:  p.title,
        product_type:  p.type,        // e.g. "Single Origin", "Blend"
        vendor:        p.vendor,
        price:         p.variants && p.variants[0] ? p.variants[0].price / 100 : null,
        currency:      (window.Shopify && Shopify.currency) ? Shopify.currency.active : 'USD',
        has_variants:  p.variants ? p.variants.length > 1 : false,
        variant_count: p.variants ? p.variants.length : 1,
        review_count:  getReviewCount(),
        avg_rating:    getAvgRating(),
        referrer_type: getReferrerType(),
        is_returning_customer: isReturningCustomer(),
      };
    }
 
    // product_viewed — fires on page load
    posthog.capture('product_viewed', productData);
 
    // product_image_viewed — fires when gallery image changes
    // Works with most Shopify themes that use [data-media-id] or similar
    var imageObserveCount = 0;
    document.querySelectorAll('.product__media, .product-single__photo, [data-media-id]').forEach(function(el, idx) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && imageObserveCount > 0) { // skip first (already fired product_viewed)
            posthog.capture('product_image_viewed', Object.assign({}, productData, {
              image_index: idx,
              seconds_on_product_before_click: secondsSincePageLoad(),
            }));
          }
          imageObserveCount++;
        });
      }, { threshold: 0.8 });
      observer.observe(el);
    });
 
    // product_description_expanded — accordion / tab open
    // Targets common Shopify theme patterns
    var accordionSelectors = [
      '.accordion__button', '.collapsible-trigger',
      '[data-collapsible-trigger]', '.tab-link', '.product-tab'
    ];
    accordionSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(btn) {
        btn.addEventListener('click', function() {
          posthog.capture('product_description_expanded', Object.assign({}, productData, {
            tab_name: (btn.textContent || btn.innerText || '').trim().substring(0, 64),
            time_on_page_before_expand: secondsSincePageLoad(),
          }));
        });
      });
    });
 
    // ── VARIANT SELECTION EVENTS ──────────────────────────────
    // Shopify fires a 'change' event on the variant selector.
    // Works for both dropdown (<select>) and button-style selectors.
 
    var lastGrindSelected   = null;
    var lastSizeSelected    = null;
    var variantSelections   = 0;
 
    // Normalise option name → category
    function getOptionCategory(optionName) {
      var lower = (optionName || '').toLowerCase();
      if (/grind|grinder|grindsize|grind.size|grind type/i.test(lower)) return 'grind';
      if (/size|weight|bag.?size|quantity/i.test(lower))                 return 'size';
      if (/roast/i.test(lower))                                          return 'roast';
      return 'other';
    }
 
    // Listen on all <select> variant dropdowns
    document.querySelectorAll('select[name^="options"]').forEach(function(sel, optIdx) {
      var optionName = sel.getAttribute('data-option') ||
                       (document.querySelectorAll('.selector-wrapper label')[optIdx] || {}).textContent || '';
      var category   = getOptionCategory(optionName);
 
      sel.addEventListener('change', function() {
        variantSelections++;
        var value = sel.value;
 
        if (category === 'grind') {
          posthog.capture('grind_type_selected', Object.assign({}, productData, {
            grind_selected:          value,
            previous_grind:          lastGrindSelected,
            is_first_selection:      lastGrindSelected === null,
            selection_number:        variantSelections,
            time_to_select_seconds:  secondsSincePageLoad(),
            scroll_depth_pct:        getScrollDepthPct(),
          }));
          lastGrindSelected = value;
 
        } else if (category === 'size') {
          posthog.capture('bag_size_selected', Object.assign({}, productData, {
            size_selected:           value,
            previous_size:           lastSizeSelected,
            time_to_select_seconds:  secondsSincePageLoad(),
          }));
          lastSizeSelected = value;
 
        } else {
          posthog.capture('variant_selected', Object.assign({}, productData, {
            option_name:   optionName,
            value_selected: value,
            category:       category,
          }));
        }
      });
    });
 
    // Also listen on swatch/button-style variant pickers
    document.querySelectorAll('.swatch input, .variant-input-wrap input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', function() {
        var optionName = input.closest('[data-option-name]') ?
          input.closest('[data-option-name]').getAttribute('data-option-name') :
          (input.getAttribute('name') || '');
        var category = getOptionCategory(optionName);
        variantSelections++;
 
        if (category === 'grind') {
          posthog.capture('grind_type_selected', Object.assign({}, productData, {
            grind_selected:         input.value,
            previous_grind:         lastGrindSelected,
            is_first_selection:     lastGrindSelected === null,
            selection_number:       variantSelections,
            time_to_select_seconds: secondsSincePageLoad(),
          }));
          lastGrindSelected = input.value;
        } else if (category === 'size') {
          posthog.capture('bag_size_selected', Object.assign({}, productData, {
            size_selected:          input.value,
            previous_size:          lastSizeSelected,
          }));
          lastSizeSelected = input.value;
        }
      });
    });
 
    // subscription_toggle_clicked — for apps like Recharge / Bold Subscriptions
    // Targets common subscribe-and-save toggle patterns
    document.querySelectorAll(
      '.rc_widget__option, [data-purchase-type], .subscribe-button, ' +
      'input[name="purchase_type"], input[name="selling_plan"]'
    ).forEach(function(el) {
      el.addEventListener('change', function() {
        var isSubscription = /subscri|recurring/i.test(el.value);
        posthog.capture('subscription_toggle_clicked', Object.assign({}, productData, {
          toggled_to:         isSubscription ? 'subscription' : 'one_time',
          frequency_selected: getSubscriptionFrequency(),
          time_on_page:       secondsSincePageLoad(),
        }));
      });
    });
 
    function getSubscriptionFrequency() {
      var freqEl = document.querySelector('[name="selling_plan"] option:checked, .rc_widget__option--selected');
      return freqEl ? (freqEl.textContent || freqEl.value || '').trim().substring(0, 32) : 'unknown';
    }
 
  } // end product page
 
 
  // ═══════════════════════════════════════════════════════════
  // 2. ADD TO CART — intercept all ATC forms & AJAX calls
  // ═══════════════════════════════════════════════════════════
  function captureAddToCart(formEl, responseData) {
    var variantId  = formEl ? (formEl.querySelector('[name="id"]') || {}).value : null;
    var quantity   = formEl ? parseInt((formEl.querySelector('[name="quantity"]') || {}).value || '1') : 1;
    var isSubscription = formEl ?
      !!formEl.querySelector('[name="selling_plan"]:not([value=""])')
      : false;
 
    // Attempt to find product info from the page or response
    var productId   = formEl ? formEl.getAttribute('data-product-id') : null;
    var productName = document.title.replace(/ [–—-].*$/, '').trim();
    var price       = formEl ?
      parseFloat((formEl.querySelector('[name="price"]') || { value: '0' }).value) / 100 : 0;
 
    posthog.capture('add_to_cart', {
      product_id:              productId,
      product_name:            productName,
      variant_id:              String(variantId),
      grind:                   lastGrindSelected,   // captured above
      size:                    lastSizeSelected,
      quantity:                quantity,
      price:                   price,
      is_subscription:         isSubscription,
      time_on_page_before_atc: secondsSincePageLoad(),
      scroll_depth_before_atc: getScrollDepthPct(),
      is_returning_customer:   isReturningCustomer(),
      session_number:          sessionNumber,
    });
  }
 
  // Method A: Intercept native form submit
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      captureAddToCart(form, null);
    });
  });
 
  // Method B: Intercept AJAX add-to-cart (fetch / XMLHttpRequest)
  // Many Shopify themes use fetch('/cart/add.js') without a real form submit
  // Safe wrapper: captures the original fetch at THIS point in time,
  // so conflicts with other apps (e.g. Webrex) that also override fetch are isolated.
  (function() {
    var originalFetch = window.fetch.bind(window);
    var _fetchOverrideInstalled = false;
    if (_fetchOverrideInstalled) return;
    _fetchOverrideInstalled = true;
 
    window.fetch = function(url, opts) {
      var result;
      try {
        result = originalFetch.apply(this, arguments);
      } catch(e) {
        return Promise.reject(e);
      }
      if (typeof url === 'string' && url.indexOf('/cart/add') > -1) {
        result.then(function(res) {
          // Clone so we don't consume the body
          var clone = res.clone();
          clone.json().then(function(data) {
            posthog.capture('add_to_cart', {
              product_id:              String(data.product_id || ''),
              product_name:            data.product_title || '',
              variant_id:              String(data.variant_id || data.id || ''),
              grind:                   lastGrindSelected,
              size:                    lastSizeSelected,
              quantity:                data.quantity || 1,
              price:                   (data.price || 0) / 100,
              is_subscription:         !!(data.selling_plan_allocation),
              time_on_page_before_atc: secondsSincePageLoad(),
              scroll_depth_before_atc: getScrollDepthPct(),
              is_returning_customer:   isReturningCustomer(),
              source:                  'ajax_fetch',
            });
          }).catch(function(){});
        }).catch(function(){});
      }
      return result;
    };
  })(); // end safe fetch wrapper
 
  // Method C: XHR fallback for older themes
  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._phUrl = url;
    return originalXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._phUrl && this._phUrl.indexOf('/cart/add') > -1) {
      this.addEventListener('load', function() {
        try {
          var data = JSON.parse(this.responseText);
          posthog.capture('add_to_cart', {
            product_id:   String(data.product_id || ''),
            product_name: data.product_title || '',
            variant_id:   String(data.id || ''),
            grind:        lastGrindSelected,
            size:         lastSizeSelected,
            quantity:     data.quantity || 1,
            price:        (data.price || 0) / 100,
            source:       'ajax_xhr',
          });
        } catch(e) {}
      });
    }
    return originalXHRSend.apply(this, arguments);
  };
 
  // add_to_cart_failed — capture when ATC button is clicked on OOS variant
  document.querySelectorAll('.btn--add-to-cart, [name="add"], .product-form__submit').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled || btn.classList.contains('sold-out') || btn.classList.contains('unavailable')) {
        posthog.capture('add_to_cart_failed', {
          product_name:     document.title.replace(/ [–—-].*$/, '').trim(),
          grind_attempted:  lastGrindSelected,
          size_attempted:   lastSizeSelected,
          error_type:       'out_of_stock',
        });
      }
    });
  });
 
  // notify_me_clicked — back in stock forms
  document.querySelectorAll('.back-in-stock-form, .notify-me-form, [data-notify-form]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      posthog.capture('notify_me_clicked', {
        product_name:    document.title.replace(/ [–—-].*$/, '').trim(),
        grind:           lastGrindSelected,
        size:            lastSizeSelected,
        email_provided:  !!form.querySelector('[type="email"]') &&
                         !!form.querySelector('[type="email"]').value,
      });
    });
  });
 
 
  // ═══════════════════════════════════════════════════════════
  // 3. CART PAGE EVENTS
  // ═══════════════════════════════════════════════════════════
  if (window.location.pathname === '/cart') {
 
    // cart_viewed — fetch live cart state via AJAX
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        posthog.capture('cart_viewed', {
          cart_value:       cart.total_price / 100,
          item_count:       cart.item_count,
          has_subscription: cart.items.some(function(i) { return !!i.selling_plan_allocation; }),
          currency:         cart.currency,
          is_returning_customer: isReturningCustomer(),
        });
      })
      .catch(function(){});
 
    // Upsell interactions
    document.querySelectorAll('.cart-upsell, [data-upsell], .upsell-widget').forEach(function(el) {
      el.addEventListener('click', function(e) {
        var isAccept  = e.target.closest('.upsell-accept, .upsell-add, [data-upsell-accept]');
        var isDismiss = e.target.closest('.upsell-dismiss, .upsell-close, [data-upsell-dismiss]');
        if (isAccept || isDismiss) {
          posthog.capture(isAccept ? 'upsell_accepted' : 'upsell_dismissed', {
            upsell_type:  el.getAttribute('data-upsell-type') || 'unknown',
          });
        }
      });
    });
  }
 
  // Cart drawer cart_viewed (for themes with slide-out cart)
  document.addEventListener('click', function(e) {
    var drawerTrigger = e.target.closest('[href="/cart"], [data-cart-trigger], .cart-icon-bubble, .site-header__cart');
    if (drawerTrigger) {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        posthog.capture('cart_drawer_opened', {
          cart_value:  cart.total_price / 100,
          item_count:  cart.item_count,
        });
      }).catch(function(){});
    }
  });
 
 
  // ═══════════════════════════════════════════════════════════
  // 4. COLLECTION PAGE EVENTS
  // ═══════════════════════════════════════════════════════════
  if (window.location.pathname.indexOf('/collections/') > -1) {
 
    posthog.capture('collection_viewed', {
      collection_name: document.querySelector('h1') ?
        document.querySelector('h1').textContent.trim() : window.location.pathname,
      product_count:   document.querySelectorAll('.product-card, .grid-product, [data-product-card]').length,
      referrer_type:   getReferrerType(),
    });
 
    // Product card clicks
    document.querySelectorAll('.product-card, .grid-product, [data-product-card]').forEach(function(card, idx) {
      card.addEventListener('click', function() {
        var nameEl = card.querySelector('.product-card__title, .grid-product__title, h3');
        posthog.capture('collection_product_clicked', {
          product_name:        nameEl ? nameEl.textContent.trim() : 'unknown',
          grid_position:       idx + 1,
          collection:          window.location.pathname,
        });
      });
    });
 
    // Sort/filter usage
    document.querySelectorAll('[name="sort_by"], .filter-trigger, [data-filter]').forEach(function(el) {
      el.addEventListener('change', function() {
        posthog.capture('collection_filter_used', {
          filter_type:  el.name || el.getAttribute('data-filter') || 'sort',
          filter_value: el.value || (el.textContent || '').trim(),
        });
      });
    });
  }
 
 
  // ═══════════════════════════════════════════════════════════
  // 5. SEARCH EVENTS
  // ═══════════════════════════════════════════════════════════
  var searchForms = document.querySelectorAll('form[action="/search"]');
  searchForms.forEach(function(form) {
    form.addEventListener('submit', function() {
      var q = (form.querySelector('input[name="q"]') || {}).value || '';
      posthog.capture('search_performed', {
        query:        q.trim().toLowerCase(),
        query_length: q.trim().length,
        source:       'header_search',
      });
    });
  });
 
  // Predictive search results click
  document.addEventListener('click', function(e) {
    var result = e.target.closest('.predictive-search__result, [data-search-result]');
    if (result) {
      posthog.capture('search_result_clicked', {
        result_text: (result.textContent || '').trim().substring(0, 64),
        result_type: result.getAttribute('data-type') || 'product',
      });
    }
  });
 
 
  // ═══════════════════════════════════════════════════════════
  // 6. BLOG / CONTENT ENGAGEMENT
  // ═══════════════════════════════════════════════════════════
  if (window.location.pathname.indexOf('/blogs/') > -1 ||
      window.location.pathname.indexOf('/pages/') > -1) {
 
    posthog.capture('content_viewed', {
      content_type: window.location.pathname.indexOf('/blogs/') > -1 ? 'blog_post' : 'page',
      title:        document.title,
      url:          window.location.pathname,
      referrer_type: getReferrerType(),
    });
 
    // Scroll depth milestones on articles (25/50/75/100%)
    var milestones = { 25: false, 50: false, 75: false, 100: false };
    window.addEventListener('scroll', function() {
      var depth = getScrollDepthPct();
      [25, 50, 75, 100].forEach(function(m) {
        if (!milestones[m] && depth >= m) {
          milestones[m] = true;
          posthog.capture('content_scroll_depth', {
            depth_pct:    m,
            content_title: document.title,
          });
        }
      });
    }, { passive: true });
  }
 
 
  // ═══════════════════════════════════════════════════════════
  // 7. EMAIL CAPTURE (Newsletter / Popup)
  // ═══════════════════════════════════════════════════════════
  document.querySelectorAll(
    '.klaviyo-form form, .popup-form, .newsletter-form, ' +
    'form#contact_form, [data-email-signup]'
  ).forEach(function(form) {
    form.addEventListener('submit', function() {
      var emailInput = form.querySelector('[type="email"]');
      posthog.capture('email_capture', {
        source:       form.getAttribute('data-source') || detectPopupSource(form),
        has_discount: form.textContent.indexOf('%') > -1 || form.textContent.toLowerCase().indexOf('off') > -1,
      });
      // Identity stitch on email capture
      if (emailInput && emailInput.value) {
        posthog.identify(emailInput.value.trim().toLowerCase(), {
          email:               emailInput.value.trim().toLowerCase(),
          email_capture_page:  window.location.pathname,
          email_capture_date:  new Date().toISOString().split('T')[0],
        });
      }
    });
  });
 
  function detectPopupSource(form) {
    if (form.closest('.popup, .modal, .flyout'))  return 'popup';
    if (form.closest('footer'))                   return 'footer';
    if (form.closest('.hero, .banner'))            return 'hero_banner';
    return 'inline';
  }
 
 
  // ═══════════════════════════════════════════════════════════
  // 8. SCROLL DEPTH — PRODUCT PAGES (for reviews visibility)
  // ═══════════════════════════════════════════════════════════
  if (window.location.pathname.indexOf('/products/') > -1) {
    var reviewsSeen = false;
    var reviewsEl   = document.querySelector(
      '#shopify-product-reviews, .spr-container, .reviews, [data-reviews-section]'
    );
 
    if (reviewsEl) {
      var reviewObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !reviewsSeen) {
            reviewsSeen = true;
            posthog.capture('product_reviews_viewed', {
              product_name:        document.title.replace(/ [–—-].*$/, '').trim(),
              time_to_reviews_sec: secondsSincePageLoad(),
            });
          }
        });
      }, { threshold: 0.3 });
      reviewObserver.observe(reviewsEl);
    }
  }
 
 
  // ═══════════════════════════════════════════════════════════
  // 9. EXIT INTENT
  // ═══════════════════════════════════════════════════════════
  var exitIntentFired = false;
  document.addEventListener('mouseleave', function(e) {
    if (e.clientY < 10 && !exitIntentFired) {
      exitIntentFired = true;
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        posthog.capture('exit_intent_detected', {
          page_type:    getPageType(),
          cart_value:   cart.total_price / 100,
          item_count:   cart.item_count,
          time_on_page: secondsSincePageLoad(),
          scroll_depth: getScrollDepthPct(),
        });
      }).catch(function(){});
    }
  });
 
 
  // ═══════════════════════════════════════════════════════════
  // 10. UTILITY FUNCTIONS
  // ═══════════════════════════════════════════════════════════
  function getReferrerType() {
    var ref = document.referrer;
    if (!ref) return 'direct';
    if (/google|bing|yahoo|duckduckgo/i.test(ref))  return 'organic_search';
    if (/facebook|instagram|tiktok|pinterest/i.test(ref)) return 'social';
    if (ref.indexOf(window.location.hostname) > -1)  return 'internal';
    return 'referral';
  }
 
  function getPageType() {
    var path = window.location.pathname;
    if (path === '/')                           return 'homepage';
    if (path.indexOf('/products/') > -1)        return 'product';
    if (path.indexOf('/collections/') > -1)     return 'collection';
    if (path === '/cart')                       return 'cart';
    if (path.indexOf('/blogs/') > -1)           return 'blog';
    if (path.indexOf('/pages/') > -1)           return 'page';
    return 'other';
  }
 
  function getReviewCount() {
    var el = document.querySelector('.spr-summary-caption, .review-count, [data-review-count]');
    if (!el) return 0;
    var match = (el.textContent || '').match(/(\d+)/);
    return match ? parseInt(match[1]) : 0;
  }
 
  function getAvgRating() {
    var el = document.querySelector('.spr-starrating, [data-rating], .shopify-product-reviews-badge');
    if (!el) return null;
    var match = (el.getAttribute('data-rating') || el.textContent || '').match(/([\d.]+)/);
    return match ? parseFloat(match[1]) : null;
  }
 
  // Register page type as super property
  posthog.register({ page_type: getPageType() });
 
  // Expose lastGrindSelected / lastSizeSelected for experiments script
  window._phLastGrind = function() { return lastGrindSelected; };
  window._phLastSize  = function() { return lastSizeSelected; };
 
  console.log('[PostHog] Whatdaphin tracking loaded ✓');
 
})();
 